// extracted by mini-css-extract-plugin
module.exports = {"body":"permissionModal_body__3KBvy"};